import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-transparent border rounded-primary-radius py-6 px-8 h-full max-h-[300px] xxl:max-h-[350px] overflow-y-auto" }
const _hoisted_2 = { class: "text-[#616068] text-base leading-[26px] tracking-[0.01rem] font-medium" }
const _hoisted_3 = { class: "text-[#898790] text-base leading-[26px] tracking-[0.01rem] font-light" }



type Props = {
  answers: Array<{
    question: string;
    answer: string;
  }>;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireAnswerReview',
  props: {
    answers: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.answers, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.question,
        class: _normalizeClass(index === __props.answers.length - 1 ? 'mb-0' : 'mb-5')
      }, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(item.question), 1),
        _createElementVNode("h5", _hoisted_3, _toDisplayString(item.answer), 1)
      ], 2))
    }), 128))
  ]))
}
}

})